module.exports = __webpack_public_path__ + "assets/img/ee17-ss.svg";